import { combineReducers } from 'redux';

import type { DlpOrder } from './dlpOrder.model';
import { dlpOrderFormReducer } from './form/dlpOrderForm.reducer';
import { orderReducer } from './order/order.reducer';

export const dlpOrderReducer = combineReducers<DlpOrder>({
  form: dlpOrderFormReducer,
  order: orderReducer,
});
